import React from "react";
import { Grid, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { GearIcon } from "../../../../assets/icons";
import { useAppSelector } from "../../../../custom-hooks/redux/redux";
import { AUTHORIZATIONS } from "../../../../utils/constants/authorization-constants";

const ManageLetterAddresseesLink = () => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.manage_mail";

  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);

  const canManageLetterAddressees =
    (currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanUploadIncoming) ||
      currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanUploadOutgoing) ||
      currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanProcessOutgoing)) ??
    false;

  return (
    <>
      {canManageLetterAddressees ? (
        <Grid
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "5px",
            width: "100%",
          }}
        >
          <Tooltip title={`${t(`${tRP}.manage_letter_addressees`)}`}>
            <span>
            <GearIcon />
            </span>
          </Tooltip>
        </Grid>
      ) : (
        <>{""}</>
      )}
    </>
  );
};
export default ManageLetterAddresseesLink;
